var map = {
	"./queries/collections/Collection": 441,
	"./queries/collections/Collection.gql": 441,
	"./queries/collections/Collections": 442,
	"./queries/collections/Collections.gql": 442,
	"./queries/products/FeaturedProducts": 443,
	"./queries/products/FeaturedProducts.gql": 443,
	"./queries/products/Offers": 414,
	"./queries/products/Offers.gql": 414,
	"./queries/products/OffersDrawer": 444,
	"./queries/products/OffersDrawer.gql": 444,
	"./queries/products/Product": 445,
	"./queries/products/Product.gql": 445,
	"./queries/products/ProductsSearch": 412,
	"./queries/products/ProductsSearch.gql": 412,
	"./queries/products/SimilarProducts": 415,
	"./queries/products/SimilarProducts.gql": 415,
	"./queries/taxonomies/Application": 446,
	"./queries/taxonomies/Application.gql": 446,
	"./queries/taxonomies/Applications": 416,
	"./queries/taxonomies/Applications.gql": 416,
	"./queries/taxonomies/BrandLogos": 413,
	"./queries/taxonomies/BrandLogos.gql": 413,
	"./queries/taxonomies/Brands": 418,
	"./queries/taxonomies/Brands.gql": 418,
	"./queries/taxonomies/Categories": 599,
	"./queries/taxonomies/Categories.gql": 599,
	"./queries/taxonomies/CategoryPage": 419,
	"./queries/taxonomies/CategoryPage.gql": 419,
	"./queries/taxonomies/HomeCategories": 420,
	"./queries/taxonomies/HomeCategories.gql": 420,
	"./queries/taxonomies/Taxonomy": 303,
	"./queries/taxonomies/Taxonomy.gql": 303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 857;